import React, { useState } from 'react'
import gym from '../../assets/hero_image.png'
import './index.css';
/* import Button from '../../components/Button'; */
import InputField from '../../components/TextInput/InputField';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
const JointNow = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        email: "",
        phone: "",
        address: "",
        cnic: "",
        bloodGroup: "",
        fatherName: "",
        startingWeight: "",
        height: "",
        diseases: [],
        fitnessGoal: "",
        timeSlot: "",
      });
      const diseasesList = [
        "Diabetes",
        "Hypertension",
        "Heart Disease",
        "Asthma",
        "None",
      ];
      const timeSlots = ["Morning", "Afternoon", "Evening", "Night"];
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      const handleCheckboxChange = (disease) => {
        const updatedDiseases = formData.diseases.includes(disease)
          ? formData.diseases.filter((d) => d !== disease)
          : [...formData.diseases, disease];
        setFormData({ ...formData, diseases: updatedDiseases });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted:", formData);
      };
    
  return (
  
   <>
   
   <div>
   <Header/>
      <div className="main-header  d-flex align-items-center">
        
        <div className="col-md-8">
          <h1>GYM MEMBERSHIP FORM</h1>
          <p className='txt'>3147 Patterson Street, Houston, TX, 77002</p>
        </div>
      </div>

      {/* Form Section */}
      <div className='marginLR'>
      <div className="container forms-container ">
      <h2 className="text-center  mb-4">Join Our Gym Today!</h2>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <InputField
              label="First Name"
              id="firstName"
              name="firstName"
              placeholder="Enter your first name"
              value={formData.firstName}
              onChange={handleChange}
              required
              className="col-md-6 mb-3"
            />
            <InputField
              label="Last Name"
              id="lastName"
              name="lastName"
              placeholder="Enter your last name"
              value={formData.lastName}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label item-label">Gender</label>
              <div>
                {["Male", "Female", "Other"].map((g) => (
                  <div className="form-check form-check-inline" key={g}>
                    <input
                      className="form-check-input check-input-gym"
                      type="radio"
                      name="gender"
                      value={g}
                      checked={formData.gender === g}
                      onChange={handleChange}
                      id={`gender-${g}`}
                    />
                    <label className="form-check-label" htmlFor={`gender-${g}`}>
                      {g}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <InputField
              label="Date of Birth"
              id="dob"
              name="dob"
              placeholder="MM-DD-YYYY"
              value={formData.dob}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
          </div>
          <div className="row">
            <InputField
              label="CNIC"
              id="cnic"
              name="cnic"
              placeholder="Enter your CNIC"
              value={formData.cnic}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
            <InputField
              label="Father's Name"
              id="fatherName"
              name="fatherName"
              placeholder="Enter your father's name"
              value={formData.fatherName}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
          </div>
          <div className="row">
            <InputField
              label="Email"
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
            <InputField
              label="Phone Number"
              type="tel"
              id="phone"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
          </div>
          <InputField
            label="Address"
            id="address"
            name="address"
            placeholder="Enter your address"
            value={formData.address}
            onChange={handleChange}
            className="mb-3"
          />
          <div className="row">
            <InputField
              label="Starting Weight (kg)"
              id="startingWeight"
              name="startingWeight"
              placeholder="Enter your starting weight"
              value={formData.startingWeight}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
            <InputField
              label="Height (cm)"
              id="height"
              name="height"
              placeholder="Enter your height"
              value={formData.height}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
          </div>
          <div className="row">
            <InputField
              label="Blood Group"
              id="bloodGroup"
              name="bloodGroup"
              placeholder="Enter your blood group"
              value={formData.bloodGroup}
              onChange={handleChange}
              className="col-md-6 mb-3"
            />
            <div className="col-md-6 mb-3">
              <label className="form-label">Preferred Time Slot</label>
              <select
                className="form-select"
                name="timeSlot"
                value={formData.timeSlot}
                onChange={handleChange}
                style={{
                  color: formData.timeSlot ? "black" : "black", 
                 
                  fontStyle:'italic'
                }}
              >
                <option value="" className='txtcolors'>Select your preferred time</option>
                {timeSlots.map((slot) => (
                  <option value={slot} key={slot}>
                    {slot}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Diseases (if any)</label>
            <div className="d-flex flex-wrap">
              {diseasesList.map((disease) => (
                <div className="form-check me-3" key={disease}>
                  <input
                    type="checkbox"
                    className="form-check-input check-input-gym"
                    id={disease}
                    value={disease}
                    checked={formData.diseases.includes(disease)}
                    onChange={() => handleCheckboxChange(disease)}
                  />
                  <label className="form-check-label" htmlFor={disease}>
                    {disease}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label item-label">Fitness Goal</label>
            <textarea
              className="form-control gym-form-control"
              name="fitnessGoal"
              placeholder="What do you aim to achieve?"
              value={formData.fitnessGoal}
              onChange={handleChange}
            ></textarea>
          </div>
          <button type="submit" className="btn btn-submit w-100">
            Join Now
          </button>
        </form>
      </div>
      </div>
     
    </div>
    <Footer/>
   </>
     

  )
}

export default JointNow
